/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { validateNumber } from "ember-changeset-validations/validators";
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  journalEventProperties = [
    ...this.sharedProperties,
    ...this.cardioPathologyProperties
  ];

  get validations(): Record<string, unknown> {
    return {
      fevg: validateNumber({
        allowBlank: true,
        positive: true,
        gte: 0,
        lte: 100,
        integer: true,
        description: "FEVG"
      })
    };
  }

  get cardioPathologyProperties(): string[] {
    return [
      "transplantDate",
      "transplantRank",
      "transplantedOrgan",
      "underlyingDisease",
      "cytomegalovirusStatus",
      "heartFailureType",
      "diagnosticDate",
      "nyhaStage",
      "fevg"
    ];
  }

  retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (!this.isLoadedFromJe) {
      model.transplantedOrgan = "heart";
    }

    return model;
  }
}
